import { NavBar, Form, Button, Input, DatePicker, Selector, Toast } from 'antd-mobile'
import React, { useCallback, useRef, useState } from 'react'
import '../../styles/pages/game-form.css'
import { useNavigate } from 'react-router-dom'
import moment from "moment";
import API_ROUTES from '../../api';
import axios from 'axios';


export default function GameCreate() {

    const [buttomLoading, setButtomLoading] = useState(false)
    const userInfo = localStorage.getItem("memberInfo");
    const memberInfo = userInfo ? JSON.parse(userInfo) : null;
    const navigate = useNavigate()

    const createGamefunc = (values) => {
        const matchTime = moment(values.startTime).format('YYYY-MM-DD HH:mm:ss');
        Toast.show({ icon: 'loading', duration: 0 });
        setButtomLoading(true)
        axios.post(API_ROUTES.game_create, {
            matchTime: matchTime,
            address: position,
            type: values.type[0],
            gameCourse: values.course[0],
            teamType: 2,
            gameName: values.gameName,
            gameType: values.gameType[0],
            gameRemark: values.gameRemark,
            lat: latPos,
            lng: lngPos
        }, {
            headers: { "Authorization": memberInfo.id }
        })
            .then(function (response) {
                if (response.data.code === 200) {
                    Toast.show({
                        // 内讧赛先保存为待发布草稿，管理员还需在首页发布后才能开放报名。
                        content: Number(values.gameType[0]) === 3 ? '创建成功，请在首页发布比赛' : '创建成功！',
                        icon: 'success',
                        afterClose: () => navigate('/home'),
                    })
                } else {
                    Toast.show({ content: response.data.msg, icon: 'fail' })
                }
            })
            .catch(function (error) {
                Toast.show({ content: '创建失败,请重试!', icon: 'fail' })
            })
            .finally(() => setButtomLoading(false));
    }

    const minDate = new Date()
    const datePickerRef = useRef();
    const handleDatePickerClick = () => datePickerRef.current?.open();

    const [lngPos, setLngPos] = useState(104.0774)
    const [latPos, setLatPos] = useState(30.64728)
    const [position, setPosition] = useState("四川大学华西校区东区-足球场")

    return (
        <div className="game-form-page game-form-page--create game-form-container has-unified-nav">
            <NavBar className="unified-navbar fixed" onBack={() => window.history.back()}>
                发起新挑战
            </NavBar>

            <div className="form-section-header">
                <span className="title">赛事立项信息</span>
            </div>

            <Form
                layout='vertical'
                className="game-form-premium"
                name='form'
                // 创建时预选“待定人数、三节制”，提交参数始终有值，仍可切换为四节。
                initialValues={{ type: ['0'], course: ['3'] }}
                onFinish={(values) => createGamefunc(values)}
                footer={
                    <div className="form-footer-premium">
                        <Button
                            type='submit'
                            className="submit-btn-premium"
                            loading={buttomLoading}
                        >
                            创建比赛
                        </Button>
                    </div>
                }
            >
                <Form.Item
                    name='gameName'
                    label='赛事全称'
                    rules={[{ required: true, message: '请输入赛事名称' }]}
                >
                    <Input placeholder='例：科朋内讧赛' />
                </Form.Item>

                <Form.Item
                    name='gameType'
                    label='赛事性质'
                    className="nature-selector"
                    rules={[{ required: true, message: '请选择比赛性质' }]}
                >
                    <Selector
                        columns={2}
                        options={[
                            { label: "内讧赛", value: 3 },
                            { label: '友谊赛', value: 1 },
                            { label: '训练赛', value: 5 },
                            { label: '活动赛', value: 2 },
                        ]}
                    />
                </Form.Item>

                <Form.Item
                    name='gameRemark'
                    label='备注说明'
                >
                    <Input placeholder='填写一些叮嘱或装备要求...' />
                </Form.Item>

                <Form.Item
                    name='type'
                    label='对抗人数 (每队)'
                    className="mode-selector"
                    help='系统将根据此人数自动匹配战术板规模'
                >
                    <Selector
                        columns={3}
                        options={[
                            { label: '8:8', value: '1' },
                            { label: '9:9', value: '4' },
                            { label: '11:11', value: '2' },
                            { label: '12:12', value: '3' },
                            { label: '待定', value: '0' },
                        ]}
                    />
                </Form.Item>

                <Form.Item
                    name='course'
                    label='赛程安排'
                    className="course-selector"
                    help='决定本场比赛的时间分段'
                    rules={[{ required: true, message: '请选择比赛节数' }]}
                >
                    <Selector
                        columns={2}
                        options={[
                            { label: '单节制', value: '1' },
                            { label: '两节制', value: '2' },
                            { label: '三节制', value: '3' },
                            // 内讧赛可安排四节，所选节数会写入 game_course。
                            { label: '四节制', value: '4' },
                        ]}
                    />
                </Form.Item>

                <Form.Item 
                    label='球场位置与标注' 
                    required 
                    help='请精确填写比赛进行的球场名称'
                >
                    <Input 
                        placeholder="请输入具体球场地点..." 
                        value={position}
                        onChange={val => setPosition(val)}
                    />

                    <div className="location-preset-selector">
                        <Selector
                            columns={2}
                            options={[
                                { label: '📍 华西东区', value: '四川大学华西校区东区-足球场' },
                                { label: '📍 三分球场', value: '高新区三分足球场' },
                            ]}
                            onChange={(arr) => {
                                if (arr.length) {
                                    setPosition(arr[0])
                                    // Use defaults based on selection if needed, or just let it be
                                    if (arr[0].includes('华西')) {
                                        setLatPos(30.64728)
                                        setLngPos(104.0774)
                                    }
                                }
                            }}
                        />
                    </div>
                </Form.Item>

                <Form.Item
                    name='startTime'
                    label='开赛日程'
                    trigger='onConfirm'
                    onClick={handleDatePickerClick}
                    rules={[{ required: true, message: '请设定时间' }]}
                >
                    <DatePicker
                        min={minDate}
                        ref={datePickerRef}
                        precision='minute'
                        title='安排具体时刻'
                        mode="date"
                        renderLabel={useCallback((type, data) => {
                            switch (type) {
                                case 'year': return data + '年';
                                case 'month': return data + '月';
                                case 'day': return data + '日 ';
                                case 'hour': return data + '时';
                                case 'minute': return data + '分';
                                default: return data;
                            }
                        }, [])}
                        filter={{ minute: (val) => val % 15 === 0 }}
                    >
                        {(value) =>
                            value ? (
                                <div className="adm-date-picker-value">
                                    📅 {moment(value).format('YYYY-MM-DD')} <span className="game-form-date-time">⏰ {moment(value).format('HH:mm')}</span>
                                </div>
                            ) : <div className="adm-date-picker-value adm-date-picker-value--placeholder">请点击设定具体赛程日期</div>
                        }
                    </DatePicker>
                </Form.Item>
            </Form>
        </div>
    )
}
